<div class="label" *ngIf="label">{{ label }}</div>
<div (click)="change()" class="b-switcher {{ value ? 'truthy' : 'falsy'}}">
  <div class="switcher-runner">
    <div class="dot"></div>
  </div>
</div>
